import * as React from 'react'
import { HeaderPlaceholder } from 'components/rentals/styled-components/home.styled'
import Header from 'components/rentals/header'
import Footer from 'components/rentals/footer'
import { ScrollTrigger } from 'gsap-wrapper'
import OWWMenu from '../rentals/header/menu'
import GlobalStyle from 'styles/global'
import NavigationNext from '../rentals/navigation-next'
import Banner from '../rentals/banner'

import { PageWrapper, ContentWrapper } from './index.styled'

const RentalsThemeWrapper = ({
  preContent = null,
  children,
  location,
  LayoutContent,
  layout,
}) => {
  const footerRef = React.useRef(null)
  const headerRef = React.useRef(null)
  let tr

  const [showBanner, setShowBanner] = React.useState(true)

  React.useEffect(() => {
    // Hide banner on contact page
    if (typeof window !== 'undefined' && window.location.pathname.includes('/contact')) {
      setShowBanner(false)
    }

    if (headerRef && headerRef.current && footerRef && footerRef.current) {
      tr = ScrollTrigger.create({
        trigger: headerRef.current,
        start: 'top top',
        endTrigger: footerRef.current,
        end: 'bottom top',
        pin: true,
        pinSpacing: false,
      })
    }
    return () => {
      if (tr) {
        tr.kill()
      }
    }
  }, [headerRef, footerRef, children])

  return (
    <>
      <PageWrapper>
        <GlobalStyle />
        <ContentWrapper>
          {/* <Banner
            onClose={() => setShowBanner(false)}
            show={showBanner}
            linkText="Apply Now"
            link="/contact"
          /> */}
          <LayoutContent location={location}>
            {preContent}
            <HeaderPlaceholder ref={headerRef}>
              <OWWMenu />
              <Header className={layout} />
            </HeaderPlaceholder>
            {children}
            <NavigationNext />
            <Footer className={layout} />
            <div ref={footerRef} styles={{ height: "0" }} />
          </LayoutContent>
        </ContentWrapper>
      </PageWrapper>
    </>
  );
}

export default RentalsThemeWrapper
